import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BACKEND_URL } from '../helpers/constants';
import { Observable } from 'rxjs';
import { BlogPostAddModel, BlogPostGetModel } from '../interfaces/interfaces';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { S3 } from 'aws-sdk';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class BlogPostDataService {

  private GET_BLOG_POST = `${BACKEND_URL}/blogPosts/getBlogPosts`;
  private DELETE_BLOG_POST = `${BACKEND_URL}/blogPosts/deleteBlogPost`;
  private ADD_BLOG_POST = `${BACKEND_URL}/blogPosts/addBlogPost`;
  private UPDATE_BLOG_POST = `${BACKEND_URL}/blogPosts/updateBlogPost`;
  private UPDATE_BLOG_POST_IMAGES = `${BACKEND_URL}/blogPosts/updateBlogPostImages`;

  constructor(private http: HttpClient) { }

  getAllBlogPostsData(): Observable<BlogPostGetModel[]> {
    return this.http
      .get(this.GET_BLOG_POST)
      .pipe(map((r: any) => Object.values(r['result'])));
  }

  async uploadBlogPostImageData(files: any): Promise<any[]> {
    let promises = [];
    for (let file of files) {
      promises.push(new Promise((resolve, reject) => {
        const bucket = new S3(environment.IMAGE_BUCKET_CREDENTIALS);
        const key = moment().valueOf() + '-' + 'post';
        const params = {
          Bucket: 'stotrasagar-images',
          Key: key,
          Body: file,
          ACL: 'public-read',
          ContentType: file.type,
        };

        bucket.upload(params, async (err: any, data: any) => {
          if (err == null) {
            resolve(data.Location)
          } else {
            reject(err)
          }
        });
      })
      )

    }

    return Promise.all(promises)

  }

  addBlogPostData(addEvent: BlogPostAddModel) {
    try {
      return this.http.post(this.ADD_BLOG_POST, addEvent).toPromise()
    } catch (err) {
      return err as any
    }
  }

  async deleteBlogPostData(blogPostId: string, keys: string[]) {

    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: {
       blogPostId: blogPostId
      },
    };
    
    for (let key of keys) {
      await this.deleteBlogPostImage(key);
    }
    return this.http.delete(this.DELETE_BLOG_POST, options).toPromise();
  }

  async deleteBlogPostImage(link: string) {
    return new Promise((resolve, reject) => {
      const key = link.split('/')[3];
      const s3 = new S3(environment.IMAGE_BUCKET_CREDENTIALS);
      const params = {
        Bucket: 'stotrasagar-images',
        Key: key,
      };

      return s3.deleteObject(params, function (err, data) {
        if (data != null) {
          return resolve("success")
        } else {
          return reject("error")
        }
      });
    });
  }

  async updateBlogPostImageData(blogPostId: string, links: string[]) {
    return this.http.put(this.UPDATE_BLOG_POST_IMAGES, { imageUrls: links, _id: blogPostId }).toPromise();
  }

  async deleteBlogPostImageAndUpdate(blogPostId: string, link: string, links: string[]) {
    const key = link.split('/')[3];
    return new Promise((resolve, reject) => {
      const s3 = new S3(environment.IMAGE_BUCKET_CREDENTIALS);
      const params = {
        Bucket: 'stotrasagar-images',
        Key: key,
      };

      return s3.deleteObject(params, function (err, data) {
        if (data != null) {
          return resolve("success")
        } else {
          return reject("error")
        }
      });
    });

  }

  async updateBlogPostData(blogPost: BlogPostGetModel) {
    try {
      return this.http.put(this.UPDATE_BLOG_POST, blogPost).toPromise();
    } catch (err) {
      return err as any
    }
  }
}
